"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: identity/identity-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fidentity%2Fidentity-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityServiceClient = exports.idTypeToJSON = exports.idTypeFromJSON = exports.UploadPersonaDocumentResponse = exports.GovernmentIdDocument = exports.UploadPersonaDocumentRequest = exports.ScanDocuments = exports.Inquiry = exports.GetPersonaFlowResponse = exports.GetPersonaFlowRequest = exports.IdType = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const document_type_1 = require("./document-type");
const protobufPackage = 'com.step.identity.proto';
var IdType;
(function (IdType) {
    IdType["INVALID_ID_TYPE"] = "INVALID_ID_TYPE";
    IdType["DRIVERS_LICENSE"] = "DRIVERS_LICENSE";
    IdType["ID_CARD"] = "ID_CARD";
    IdType["PASSPORT"] = "PASSPORT";
    IdType["MILITARY_ID"] = "MILITARY_ID";
    IdType["PASSPORT_CARD"] = "PASSPORT_CARD";
    IdType["PERMANENT_RESIDENT_CARD"] = "PERMANENT_RESIDENT_CARD";
    IdType["WORK_PERMIT"] = "WORK_PERMIT";
    IdType["VISA"] = "VISA";
    IdType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(IdType || (exports.IdType = IdType = {}));
function createBaseGetPersonaFlowRequest() {
    return { supportedScanDocuments: [] };
}
exports.GetPersonaFlowRequest = {
    fromJSON(object) {
        const message = {
            supportedScanDocuments: globalThis.Array.isArray(object?.supportedScanDocuments)
                ? object.supportedScanDocuments.map((e) => (0, document_type_1.documentTypeFromJSON)(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.supportedScanDocuments?.length) {
            obj.supportedScanDocuments = message.supportedScanDocuments.map((e) => (0, document_type_1.documentTypeToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetPersonaFlowRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPersonaFlowRequest();
        message.supportedScanDocuments = object.supportedScanDocuments?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetPersonaFlowResponse() {
    return { inquiry: undefined, scanDocuments: undefined, inquiryUrl: '' };
}
exports.GetPersonaFlowResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.inquiry)) {
            message.inquiry = exports.Inquiry.fromJSON(object.inquiry);
        }
        if (isSet(object.scanDocuments)) {
            message.scanDocuments = exports.ScanDocuments.fromJSON(object.scanDocuments);
        }
        if (isSet(object.inquiryUrl)) {
            message.inquiryUrl = globalThis.String(object.inquiryUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.inquiry !== undefined) {
            obj.inquiry = exports.Inquiry.toJSON(message.inquiry);
        }
        if (message.scanDocuments !== undefined) {
            obj.scanDocuments = exports.ScanDocuments.toJSON(message.scanDocuments);
        }
        if (message.inquiryUrl !== undefined && message.inquiryUrl !== '') {
            obj.inquiryUrl = message.inquiryUrl;
        }
        return obj;
    },
    create(base) {
        return exports.GetPersonaFlowResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPersonaFlowResponse();
        message.inquiry = (object.inquiry !== undefined && object.inquiry !== null)
            ? exports.Inquiry.fromPartial(object.inquiry)
            : undefined;
        message.scanDocuments = (object.scanDocuments !== undefined && object.scanDocuments !== null)
            ? exports.ScanDocuments.fromPartial(object.scanDocuments)
            : undefined;
        message.inquiryUrl = object.inquiryUrl ?? '';
        return message;
    },
};
function createBaseInquiry() {
    return { url: '', id: '', sessionToken: '' };
}
exports.Inquiry = {
    fromJSON(object) {
        const message = {
            url: isSet(object.url) ? globalThis.String(object.url) : '',
            id: isSet(object.id) ? globalThis.String(object.id) : '',
        };
        if (isSet(object.sessionToken)) {
            message.sessionToken = globalThis.String(object.sessionToken);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== '') {
            obj.url = message.url;
        }
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.sessionToken !== undefined && message.sessionToken !== '') {
            obj.sessionToken = message.sessionToken;
        }
        return obj;
    },
    create(base) {
        return exports.Inquiry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInquiry();
        message.url = object.url ?? '';
        message.id = object.id ?? '';
        message.sessionToken = object.sessionToken ?? '';
        return message;
    },
};
function createBaseScanDocuments() {
    return { scanDocuments: [] };
}
exports.ScanDocuments = {
    fromJSON(object) {
        const message = {
            scanDocuments: globalThis.Array.isArray(object?.scanDocuments)
                ? object.scanDocuments.map((e) => (0, document_type_1.documentTypeFromJSON)(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.scanDocuments?.length) {
            obj.scanDocuments = message.scanDocuments.map((e) => (0, document_type_1.documentTypeToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.ScanDocuments.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScanDocuments();
        message.scanDocuments = object.scanDocuments?.map((e) => e) || [];
        return message;
    },
};
function createBaseUploadPersonaDocumentRequest() {
    return { governmentId: undefined, frontPhoto: '', backPhoto: '' };
}
exports.UploadPersonaDocumentRequest = {
    fromJSON(object) {
        const message = {
            frontPhoto: isSet(object.frontPhoto) ? globalThis.String(object.frontPhoto) : '',
        };
        if (isSet(object.governmentId)) {
            message.governmentId = exports.GovernmentIdDocument.fromJSON(object.governmentId);
        }
        if (isSet(object.backPhoto)) {
            message.backPhoto = globalThis.String(object.backPhoto);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.governmentId !== undefined) {
            obj.governmentId = exports.GovernmentIdDocument.toJSON(message.governmentId);
        }
        if (message.frontPhoto !== '') {
            obj.frontPhoto = message.frontPhoto;
        }
        if (message.backPhoto !== undefined && message.backPhoto !== '') {
            obj.backPhoto = message.backPhoto;
        }
        return obj;
    },
    create(base) {
        return exports.UploadPersonaDocumentRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUploadPersonaDocumentRequest();
        message.governmentId = (object.governmentId !== undefined && object.governmentId !== null)
            ? exports.GovernmentIdDocument.fromPartial(object.governmentId)
            : undefined;
        message.frontPhoto = object.frontPhoto ?? '';
        message.backPhoto = object.backPhoto ?? '';
        return message;
    },
};
function createBaseGovernmentIdDocument() {
    return { countryCode: '', type: IdType.INVALID_ID_TYPE };
}
exports.GovernmentIdDocument = {
    fromJSON(object) {
        const message = {
            countryCode: isSet(object.countryCode) ? globalThis.String(object.countryCode) : '',
            type: isSet(object.type) ? idTypeFromJSON(object.type) : IdType.INVALID_ID_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.countryCode !== '') {
            obj.countryCode = message.countryCode;
        }
        if (message.type !== IdType.INVALID_ID_TYPE) {
            obj.type = idTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.GovernmentIdDocument.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGovernmentIdDocument();
        message.countryCode = object.countryCode ?? '';
        message.type = object.type ?? IdType.INVALID_ID_TYPE;
        return message;
    },
};
function createBaseUploadPersonaDocumentResponse() {
    return {};
}
exports.UploadPersonaDocumentResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UploadPersonaDocumentResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUploadPersonaDocumentResponse();
        return message;
    },
};
function idTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ID_TYPE':
            return IdType.INVALID_ID_TYPE;
        case 1:
        case 'DRIVERS_LICENSE':
            return IdType.DRIVERS_LICENSE;
        case 2:
        case 'ID_CARD':
            return IdType.ID_CARD;
        case 3:
        case 'PASSPORT':
            return IdType.PASSPORT;
        case 4:
        case 'MILITARY_ID':
            return IdType.MILITARY_ID;
        case 5:
        case 'PASSPORT_CARD':
            return IdType.PASSPORT_CARD;
        case 6:
        case 'PERMANENT_RESIDENT_CARD':
            return IdType.PERMANENT_RESIDENT_CARD;
        case 7:
        case 'WORK_PERMIT':
            return IdType.WORK_PERMIT;
        case 8:
        case 'VISA':
            return IdType.VISA;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return IdType.UNRECOGNIZED;
    }
}
exports.idTypeFromJSON = idTypeFromJSON;
function idTypeToJSON(object) {
    switch (object) {
        case IdType.INVALID_ID_TYPE:
            return 'INVALID_ID_TYPE';
        case IdType.DRIVERS_LICENSE:
            return 'DRIVERS_LICENSE';
        case IdType.ID_CARD:
            return 'ID_CARD';
        case IdType.PASSPORT:
            return 'PASSPORT';
        case IdType.MILITARY_ID:
            return 'MILITARY_ID';
        case IdType.PASSPORT_CARD:
            return 'PASSPORT_CARD';
        case IdType.PERMANENT_RESIDENT_CARD:
            return 'PERMANENT_RESIDENT_CARD';
        case IdType.WORK_PERMIT:
            return 'WORK_PERMIT';
        case IdType.VISA:
            return 'VISA';
        case IdType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.idTypeToJSON = idTypeToJSON;
class IdentityServiceClient {
    rpc;
    name = 'com.step.identity.proto.IdentityService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/identity';
    methods = [{
            name: 'GetPersonaFlow',
            requestType: exports.GetPersonaFlowRequest,
            responseType: exports.GetPersonaFlowResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UploadPersonaDocument',
            requestType: exports.UploadPersonaDocumentRequest,
            responseType: exports.UploadPersonaDocumentResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get the flow the client should use for Persona. This is either an inquiry
     * url for using the client webview, or a list of document types the user
     * should scan in-app using Microblink and upload via API. Both options will
     * be missing if the use should not be going through the Persona flow
     * (either because it's not applicable to them or because they have already
     * completed it). In the case of an inquiry URL, the URL needs to be
     * regenerated (with a new session token) for resuming an in progress
     * inquiry.
     */
    getPersonaFlow(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Uploads a document to be used for verification as part of the Persona
     * inquiry for the user
     */
    uploadPersonaDocument(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.IdentityServiceClient = IdentityServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=identity-service.js.map